<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <h2 id="headings" class="main-headings">Custom Detector :</h2>
            <!-- <p>To submit a new request you must be logged into your Cisco account.</p> -->
        </div>
        <div class="col-md-6">
          <form  [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
             <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <div class="form-group__text" style="margin: 20px 0 0 45px">
                           <!-- <label for="sample5" class="label" >Custom Detector File</label> -->
                           <span id="file-chosen" style="padding-right: 15px;">{{file_name}}</span>
                           <div class="file">                           
                           <input #inputfile accept=".csv" type="file" id="actual-btn"  name="pcapFile" style="width: 100%;" (change)="onFileSelect($event)" hidden/>
                           <label for="actual-btn">Browse</label>
                           <button class="btn btn--primary" type="submit" style="margin-left: 9px; margin-bottom: 2px; width:76px; height: 34px;">Upload</button>  
                           </div>
                          
                           
                          
                             <span class="help-block__text"> <a href="assets/custom_detector.csv" target="_blank" download="custom_detector.csv">
                                <svg width="20" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 0.625C10.6213 0.625 11.125 1.12868 11.125 1.75V9.53401L13.142 7.517C13.5813 7.07767 14.2937 7.07767 14.733 7.517C15.1723 7.95634 15.1723 8.66866 14.733 9.108L10.7955 13.0455C10.5758 13.2652 10.2879 13.375 10 13.375C9.84746 13.375 9.70201 13.3446 9.56937 13.2896C9.43668 13.2347 9.31237 13.1534 9.2045 13.0455L5.267 9.108C4.82766 8.66866 4.82766 7.95634 5.267 7.517C5.70634 7.07767 6.41866 7.07767 6.858 7.517L8.875 9.53401V1.75C8.875 1.12868 9.37868 0.625 10 0.625Z" fill="#7E868F"/>
                                    <path d="M2.875 12.25C2.875 11.6287 2.37132 11.125 1.75 11.125C1.12868 11.125 0.625 11.6287 0.625 12.25V17.5C0.625 17.9973 0.822544 18.4742 1.17417 18.8258C1.52581 19.1775 2.00272 19.375 2.5 19.375H17.5C17.9973 19.375 18.4742 19.1775 18.8258 18.8258C19.1775 18.4742 19.375 17.9973 19.375 17.5V12.25C19.375 11.6287 18.8713 11.125 18.25 11.125C17.6287 11.125 17.125 11.6287 17.125 12.25V17.125H2.875V12.25Z" fill="#7E868F"/>
                                    </svg>
                                Custom Detector Template</a> </span>
                             <div *ngIf="submitted && f.pcapFile.errors" class="invalid-feedback">
                                <div *ngIf="f.pcapFile.errors.required">Custom detector file is required</div>
                            </div>
                          </div>
                         
                        
                    </div> 

                </div>
             </div>
                        
             
                
             
                  
                
               
          </form>
        </div> 
        <div class="col-md-3">
            <button class="btn btn--primary" type="submit" style="align-items: center;margin-top: 15px;" (click)="createCustomeDetector()">Create Custome Detector</button> 
        </div>
    </div>
</div>


<!--<div class="container-fluid mainCADBody">
    <div class="row appDetTable p-b20" style="background-color: white;">
        <div class="col-12 CADSmallTableContainer CADSmallTableContainerPadding">
            <div class="CADSmallTable CADTableFull">
                <div class="table__header-row CADSmallTableHeader">

                    <div class="table__header-cell" >Web Application</div>                 
                    <div class="table__header-cell" >URL</div>
                    <div class="table__header-cell" >Count</div>
                    <div class="table__header-cell" >Output</div>
                </div>
                <div>
                    <div *ngIf="applicationList.length==0" class="table__row CADSmallTableRow no-records-bg">
                        <div class="table__cell"></div>
                        <div class="table__cell"></div>
                        <div class="table__cell">
                            <div class="no-records">No records to display.</div>
                        </div>
                        <div class="table__cell"></div>
                    </div>
                </div>
                <div class="scrollbar scrollbar--direction-vertical CADSmallTableBody">
                    <div *ngFor="let app of applicationList; let index=index">
                      <div class="table__row CADSmallTableRow" id="{{index}}">
                        
                        <div class="table__cell"><span class="resultRowPaddingServerName"
                            [ngClass]="app.serverNameColor===true ? 'showColor'  : 'showColorNone'">{{app.webApp}}</span>
                         </div>
                         <div class="table__cell"><span class="resultRowPaddingIP"
                            [ngClass]="app.ipAddressColor===true ? 'showColor'  : 'showColorNone'">{{app.url}}</span>
                         </div>
                         <div class="table__cell"><span class="resultRowPaddingServerName"
                            [ngClass]="app.serverNameColor===true ? 'showColor'  : 'showColorNone'">{{app.count}}</span>
                         </div>
                        <div class="table__cell">
                           <div class="select">
                            <select class="select__native-select">
                                <option selected="">Select Option</option>
                                <option *ngFor="let test of app.output" [value]="test">
                                    {{test}}
                                </option>
                            </select>
                            <span class="select__open-icon icon icon-chevron-down"></span>
                          </div>
                         </div>
                       </div>   
                    </div>
                </div>
            </div>
         </div>
    </div> 
   
</div>   -->
<div class="small-container-white">  
<div class="container-fluid">
<div class="row">
    <div class="col-12">
        <table class="table table--type-tight">
            <thead>
                <tr class="table__header-row">
                    <th class="table__header-cell">Web Application</th>
                    <th class="table__header-cell">URL</th>
                    <th class="table__header-cell">
                        Count
                    </th>
                    <th class="table__header-cell">
                        New Application Name
                    </th>
                </tr>
            </thead>
            <tbody>
                <div>
                    <div *ngIf="applicationList.length==0" class="table__row CADSmallTableRow no-records-bg">                     
                        <div class="table__cell">
                            <div class="no-records">No records to display.</div>
                        </div>
                    </div>
                </div>
                
                        <tr class="table__row" *ngFor="let app of applicationList;  let index=index">
                            <td class="table__cell">{{app.web_app}}</td>
                            <td class="table__cell">{{app.url}}</td>
                            <td class="table__cell ">{{app.count}}</td>
                            <td class="table__cell "> 
                              <div class="select" style="margin-bottom:0px !important">
                                <select #myselect  class="select__native-select" [(ngModel)]="selectedRow[index]"  (change)="onChangeName(myselect.value,index)" >
                                    <option *ngFor="let test of app.new_app_name" [value]="test">
                                        {{test}}
                                    </option>
                                </select>
                                <div class="accordion__card accordion__card--state-collapsed"></div>
                             <!--   <div [hidden]="myselect.value!='Other'"> 
                                <input  #textField type="text" class="input"  name="textField"
                                placeholder="New Application Name" style="width: 100% !important;" /> 
                                </div>-->
                                <span class="select__open-icon icon icon-chevron-down"></span>
                              </div>
                            </td>
                        </tr>    
               
            </tbody>
        </table>
    </div>
</div>
</div>
</div>

<!--
<div class="row" style="margin-top: 15px;">
<div class="col-md-5"></div>
<div class="col-md-2">  
    <button class="btn btn--primary" type="submit" style="align-items: center;" (click)="createCustomeDetector()">Create Custome Detector</button> 
</div>  
<div class="col-md-5"></div>      
</div> -->
 

<footer class="footer" style="padding-right: 16px; margin-top: 20px;">
    <div class="footer__legal">
        <div class="row">
            <div class="col-md-2">
                @ 2023 Cisco Systems, Inc.
            </div>
            <div class="col-md-6">

            </div>
            <div class="col-md-4">
                <a href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html" style="padding-left: 185px;
                font-weight: 700;color: #1D69CC;">Privacy policy</a>
            
                <a href="https://www.cisco.com/c/en/us/about/legal/terms-conditions.html" style="padding-left: 18px;
                font-weight: 700;color: #1D69CC;">Terms of service</a>
            </div>    
        </div>
    </div>
</footer>

<div id="feedback" class="modal modal--size-small">
    <div class="modal__dialog centerfeedback">
        <div class="modal__content">
            <div class="modal__header">
                <div class="modal__title">Set New Application Name</div>
               <a class="modal__close" (click)="closeModal('feedback')"><span class="icon-close"></span></a>  
            </div>
            <div class="modal__body">
                
                <p>Please select or enter new application name:</p>
                
                <!-- <div class="select" >
                 <select #appNameSelect  class="select__native-select"  [(ngModel)]="selectedAppName" data-show-subtext="true" data-live-search="true">
                    <option selected="Select Application Name">Select Application Name</option>
                    <option *ngFor="let test of appNameList" [value]="test" data-tokens="test">
                        {{test}}
                    </option>                    
                </select>
                <span class="select__open-icon icon icon-chevron-down"></span>
               </div> -->
               <input class="combobox" list="atoms" name="atoms" placeholder="Select or enter New Application Name"
                [(ngModel)]="selectedAppName" style="width :100%">
               <datalist class="combobox__datalist" id="atoms">
                   <option *ngFor="let test of appNameList" [value]="test" > </option>  
              </datalist>
            </div>
            <div class="modal__footer">
              <button class="btn btn--tertiary" (click)="closeModal('feedback')">Cancel</button>
                <button class="btn btn--primary" (click)="setNewApplicationName( )">Submit</button>
            </div>
        </div>
    </div>
</div>

<!--
<div id="customeDetetor" class="modal modal--size-big">
    <div class="modal__dialog customeDetetor">
        <div class="modal__content">
            <div class="modal__header">
                <div class="modal__title">Set New Application Name</div>
               <a class="modal__close" (click)="closeModal('customeDetetor')"><span class="icon-close"></span></a>  
            </div>
            <div class="modal__body">
                
                <table>
                    <tr *ngFor="let app of filterCustomeDetectorApplicationList; let index=index">
                        <div class="table__row CADSmallTableRow" id="{{index}}">
                            
                            <div class="table__cell">
                                appName : <input   name="appName1-{{index}}" [(ngModel)]="app.appName1" >
                                
                            </div>
                            
                            <div class="table__cell" >
                                appDescription : <input   name="appDescription-{{index}}" [(ngModel)]="app.appDescription" >
                          </div>
                          <div class="table__cell" >
                            Risk : <input   name="appDescription-{{index}}" [(ngModel)]="app.risk" >
                          </div>

                        </div>
                    </tr>
                </table>
                       
            </div>
        </div>
    </div>
</div>-->